import { useTranslation } from 'react-i18next';

import { CreateFolderButton } from '@/components/CreateFolder';
import UploadPdfButton from '@/components/UploadPDFButton/UploadPdfButton';
import { cn } from '@/utils';

function EmptySection({ section, className }) {
	const { t } = useTranslation();

	const ButtonComponent =
		section === 'documents' ? UploadPdfButton : CreateFolderButton;

	return (
		<div
			className={cn(
				'flex min-h-[92px] flex-col items-center justify-center gap-2 rounded bg-grey-100 px-6',
				className
			)}
		>
			<div className="self-stretch text-center text-xs font-normal leading-tight text-grey-500">
				{t(`myDocuments.${section}.empty`)}
			</div>

			<ButtonComponent size="xs">
				{t(`myDocuments.${section}.button`)}
			</ButtonComponent>
		</div>
	);
}

export default EmptySection;
